// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"VideoPlayer_wrapper__HUDCI","container":"VideoPlayer_container__u7W0b"};